import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLibraryDeps } from '../library/LibraryDeps'
import { stripHtml, type Raw } from './chatRows'
import { Icon } from './Icon'

/** The account's queued mass messages (the CRM Chats page's Scheduled panel). */
export function ScheduledPanel({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation('chats')
  const { gateway } = useLibraryDeps()
  const [rows, setRows] = useState<Raw[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let live = true
    gateway<Raw>('/v1/mass-messages/queue', {}).then(
      (d) => {
        if (!live) return
        const list = (d?.list ?? d?.queue ?? (Array.isArray(d) ? d : [])) as unknown
        setRows(Array.isArray(list) ? (list as Raw[]) : [])
      },
      (e: Error) => live && setError(e.message),
    )
    return () => {
      live = false
    }
  }, [gateway])

  const text = (r: Raw) => stripHtml(r.message ?? r.message_text ?? r.text ?? r.body ?? r.label ?? r.title ?? '') || t('scheduled.noText')
  return (
    <div className="cs-screen cs-screen--utility">
      <section className="cs-main">
        <header className="cs-head">
          <button type="button" className="chats-panel-tool" aria-label={t('stats.back')} title={t('stats.back')} onClick={onClose}>
            <Icon id="icon-back" size={18} />
          </button>
          <h1>{t('scheduled.title')}</h1>
        </header>
        <p className="cs-sub">{error ? t('scheduled.failed') : rows ? t('scheduled.count', { count: rows.length }) : t('scheduled.subtitle')}</p>
        {error && <div className="cs-error">{error}</div>}
        {rows && !rows.length && <div className="cs-empty">{t('scheduled.empty')}</div>}
        {rows && rows.length > 0 && (
          <ul className="cs-queue" aria-label={t('scheduled.label')}>
            {rows.map((r, i) => (
              <li key={String(r.id ?? r.queueId ?? i)}>
                <span className="cs-queue-id">#{String(r.id ?? r.queueId ?? r.mass_message_id ?? '')}</span> {text(r)}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  )
}
